import { Injectable } from '@angular/core';
import { Observable, delay, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { ValuationTaxDto } from '../models/valuation-tax.model';

@Injectable({
  providedIn: 'root',
})
export class ValuationTaxService {
  private mockTaxOptions: ValuationTaxDto[] = [
    {
      id: '1',
      label: 'Differenzbesteuert (inkl. Anteil MwSt)',
      value: 'DIFFERENCE',
      description: 'Standard differential taxation including VAT portion',
    },
    {
      id: '2',
      label: 'Differenzbesteuert (durchschnittlicher Anteil MwSt.)',
      value: 'DIFFERENCE_TAX_AVG_VAT',
      description: 'Differential taxation with average VAT portion',
    },
    {
      id: '3',
      label: 'Privatmarkt (MwSt neutral)',
      value: 'PRIVATE',
      description: 'Private market VAT neutral taxation',
    },
  ];

  getValuationTaxOptions(): Observable<ValuationTaxDto[]> {
    return of(this.mockTaxOptions).pipe(delay(200));
  }

  getValuationTaxById(id: string): Observable<ValuationTaxDto | null> {
    return of(null).pipe(
      delay(100),
      map(() => this.mockTaxOptions.find((option) => option.id === id) || null)
    );
  }

  getValuationTaxByValue(value: string): Observable<ValuationTaxDto | null> {
    return of(null).pipe(
      delay(100),
      map(
        () =>
          this.mockTaxOptions.find((option) => option.value === value) || null
      )
    );
  }
}
